export enum EVENT_TYPE {
  ERROR_MESSAGE,
  WARNING_MESSAGE,
  SUCCESS_MESSAGE
}
